const priceFormat = (num) => {
	if (isNaN(num)) {
		return '-';
	}
	return new Intl.NumberFormat().format(num);
};
export default priceFormat;